export function keywordsContains(keywords: string[], str?: string): boolean {
    if (!str) {
        return false
    }

    return keywords.some((keyword) => str.toLowerCase().includes(keyword.toLowerCase()))
}
